import React from 'react';

export type ContentComponent = React.FC

const Content: ContentComponent = ({ children }) => <>{children}</>;

Content.displayName = 'Content';

export default Content
